/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import CardTags from './CardTags';
import DateLine from './DateLine';
import Link from './Link';

import styles from '../../../styles/partials/event-title.module.scss';

const propTypes = {
    item: AppPropTypes.film,
    className: PropTypes.string,
    url: PropTypes.string,
    isLink: PropTypes.bool,
    onClick: PropTypes.func,
};

const defaultProps = {
    item: null,
    className: null,
    url: null,
    isLink: false,
    onClick: null,
};

const EventTitle = ({ item, className, url, isLink, onClick }) => {
    const {
        url: filmUrl = null,
        title = null,
        venue = null,
        startDate = null,
        endDate = null,
        isFree = false,
        isOnline = false,
        type = null,
        // amount = 0,
    } = item || {};

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <CardTags className={styles.tags} withOnline={isOnline} withFree={isFree} />
            <div className={styles.type}>
                {type === 'screening' ? (
                    <FormattedMessage
                        defaultMessage="Screening"
                        description="Entity type heading"
                    />
                ) : (
                    <FormattedMessage defaultMessage="Event" description="Entity type heading" />
                )}
            </div>
            <h2 className={classNames([styles.title])}>
                {isLink && (filmUrl !== null || url !== null) ? (
                    <Link
                        className={classNames([styles.link])}
                        href={url !== null ? url : filmUrl}
                        onClick={onClick !== null ? onClick : null}
                    >
                        {title}
                    </Link>
                ) : (
                    title
                )}
            </h2>
            {startDate !== null ? (
                <DateLine startDate={startDate} endDate={endDate} className={styles.date} />
            ) : null}
            {venue !== null && <div className={styles.venue}>{venue.name}</div>}
        </div>
    );
};
EventTitle.propTypes = propTypes;
EventTitle.defaultProps = defaultProps;

export default EventTitle;
